
class Servidor {
  static IP = process.env.REACT_APP_API_URL || "http://192.168.1.21:3000";
}

export default Servidor;
